/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react'
import { Box, CircularProgress, colors, Fab, IconButton, Tooltip, useTheme } from '@mui/material'
import { Check, Delete, Edit, Preview, Save } from '@mui/icons-material'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// import { tokens } from '../theme'
import { blue, green } from '@mui/material/colors'
// import { deleteUser, updateUsers } from '../actions/User';
// import { useDispatch, useSelector } from 'react-redux'
// import { getCurrentUser, setUser } from '../context/userSlice'
// import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
// import { useValue } from '../../../context/ContextProvider';
import EditIcon from '@mui/icons-material/Edit';
import { useUserContext, useUserDispatch } from '../../contexts/UserContext';
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


const UsersActions = ({ params, rowId, setRowId, webpath }) => {
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)

    const navigate = useNavigate();
    const user = useUserContext();
    const dispatch = useUserDispatch();


    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    // const { dispatch } = useValue();
    // const theme = useTheme();
    // const colors = tokens(theme.palette.mode);
    // const { currentUser, Users } = useSelector(getCurrentUser);
    // const dispatch = useDispatch();
    // const { enqueueSnackbar } = useSnackbar();
    // dispatch(setCurrentUser({...others}))
        // const updateUser = currentUser.userName
        // const curDate = new moment(Date()).format()
        // var curDate = moment();
        // console.log(curDate)

    // console.log(params.id,": ", rowId);
    // console.log(params.row);
    const handleDelete = async (id) => {
      console.log(id);
      setLoading(true);

      try {
        // const result = await updateUsers(updateUser, id, dispatch);
        const result = await axios({
          method: 'get',
          url: `${process.env.REACT_APP_API}/users.php?mode=delete&id=${id}`,
          // headers: {
          //     'Accept': 'application/json',
          //     // 'Content-type': 'application/x-www-form-urlencoded',
          //     'Content-type': 'application/json; charset=utf-8',
          //     // 'Content-Type': 'multipart/form-data'
          // },
           // data: JSON.stringify(params.row) ,
        });
        console.log(result)
        if (result.data[0]) {
            setSuccess(true);
            setRowId(null);
            navigate("/users");
            // enqueueSnackbar('Save success', {variant:'success'});
        } else
        {
            setSuccess(false);
            // setRowId(null);
            // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
        }

        setLoading(false);

    }
    catch (error) {
        // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
        setLoading(false);
        console.log(error)
      }

      setOpen(false);
      setLoading(false);
      };

    const handleSubmit =  async () => {
        setLoading(true);
        
        // let { id, ...user } = params.row;
        // const updateUser = {...user, id,  };
        let { password, Avatar, ...oth } =  params.row;
        // oth.append('mode','update');
        const updateUser = {...oth, mode:'update',  };
        // console.log(updateUser);

        try {
            // const result = await updateUsers(updateUser, id, dispatch);
            const result = await axios({
              method: 'post',
              url: `${process.env.REACT_APP_API}/users.php`,
              headers: {
                  'Accept': 'application/json',
                  // 'Content-type': 'application/x-www-form-urlencoded',
                  // 'Content-type': 'application/json; charset=utf-8',
                  'Content-Type': 'multipart/form-data'
              },
              data: JSON.stringify(updateUser) ,
            });
            // console.log(result.data[0])
            if (result.data[0]) {
                setSuccess(true);
                setRowId(null);
                // enqueueSnackbar('Save success', {variant:'success'});
            } else
            {
                setSuccess(false);
                // setRowId(null);
                // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
            }

            setLoading(false);

        }
        catch (error) {
            // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
            setLoading(false);
            console.log(error)
          }

    

        // setTimeout(() => {
        //     const { role, active, _id } = params.row;
        //     // const result = await updateStatus({ role, active }, id, dispatch);
        //     // if (result) {
        //       setSuccess(true);
        //       setRowId(null);
        //     // }
        //     // console.log(age,gender,id)
        //     // console.log(params)
        //     // alert("U click change");
        //     setLoading(false);
            
        // }, 1500);

    };

    useEffect(() => {
        if (rowId === params.id && success) setSuccess(false);

        // console.log("rowId Change")
        // console.log(params.row,currentUser,updateDate)
        // const a = [1,2,3]
        // const b = [4,5,6]
        // a.concat(b)  // = [1,2,3,4,5,6]

    }, [rowId]);

  return (
    <Box 
      width="100%"
      minWidth='150px'
      m="0 auto"
      p="5px"
      display="flex"
      justifyContent="center"
      className="items-center "
      sx={{
          m:1,
          position: 'relative',
      }}
    >
      <Box className="flex justify-center items-center">
        {success ? (
            <Fab color="primary"
                sx={{
                width: 40,
                height: 40,
                bgcolor: green[800],
                '&:hover': { bgcolor: green[300] },
                }}
            >
                <Check />
            </Fab>
        ) : (
            <Fab
                color="primary"
                size="small"
                // sx={{
                //     width: 32,
                //     height: 32,
                // }}
                disabled={params.id !== rowId || loading}
                onClick={handleSubmit}
            >
                <Save />
            </Fab>
        )}
        {loading && (
            <CircularProgress
                className="flex absolute top-0 z-10 p-1"
                size={48}
                // sx={{
                //     color: green[500],
                //     display: 'flex',
                //     position: 'relative',
                    
                //     top: 0,
                //     left: -10,
                //     zIndex: 1,
                // }}
            />
        )}
      </Box>
        {/* <Box> */}
      {/* <Tooltip title="Details"> */}
        <IconButton
          className="hover:text-yellow-600"
          onClick={() => {
                try {
                // dispatch(setUser(params.row))
                navigate(`${webpath}/${params.id}`)
                }
                catch(error) {
                    // enqueueSnackbar('!!!Error !!!', {variant:'error'});
                }
          }}
        >
          <EditIcon />
        </IconButton>
      {/* </Tooltip> */}
      {/* <Tooltip title="Delete"> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-red-500 font-bold">
          {"ยืนยันการลบ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ต้องการลบผู้ใช้ &quot;{params.row.name}&quot; ใช่หรือไม่?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => handleDelete(params.row.id)} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
        <IconButton 
          className="hover:text-red-600"
          // onClick={handleClickVariant('!!!Delete Success','success')}
          //  onClick={() => deleteUser(params.row, currentUser, dispatch)}
          onClick={handleClickOpen}
        >
          <Delete />
        </IconButton>
      {/* </Tooltip> */}
    {/* </Box> */}

    </Box>
  )
}

export default UsersActions